import sdl from '@jds/react-generated-sdl/JDSContainer';
import type { JDSContainerProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, ContainerProps } from '../logic';

const Component = (props: ContainerProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    verticalAlign = 'start',
    horizontalAlign = 'start',
    direction = 'row',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { verticalAlign, horizontalAlign, direction, ...rest },
    'JDSContainer',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Container = withLogic(Component) as React.ForwardRefExoticComponent<
  ContainerProps & React.RefAttributes<HTMLDivElement>
> & { slotName?: string };

Container.displayName = 'Container';
Container.slotName = 'jds_container';

export { Container, type JDSContainerProps };
